/**
 * NOTICE:
 * You may be wondering why there are two forms in product-form.js.
 *
 * The reason for this is the original `product-form` is very customised based on the use cases
 * for the variant framework. The decision was made by Mike to separate the `product-form-dawn`
 * which is specific to use cases which still uses the original dawn theme
 */

/**
 * Helper function that hides qty messaging
 *
 * @return {void}
 */
function hideQtyMessaging() {
  const errorContainerWrapper = document.querySelector(
    '.product-form__error-message-wrapper'
  );
  errorContainerWrapper && errorContainerWrapper.setAttribute('hidden', true);
}

/**
 * Shows the max qty messaging.
 * It shows up when the quantity + existing cart quantity
 *
 * @param {number} cartQuantity - The current quantity in the cart
 * @param {array} quantity - The quantity of the text input
 * @param {array} maxQty - The threshold before showing the max qty messaging
 *
 * @return {void}
 */
function showMaxQtyMessaging(cartQuantity, quantity, maxQty, variantId) {
  // Query all .product-form__error-message-wrapper elements with data-variant-id equal to variantId
  const otherSameProductErrorWrappers = document.querySelectorAll(`.product-form__error-message-wrapper[data-variant-id="${variantId}"]`);
  const otherSameProductErrorContainers = document.querySelectorAll(`.product-form__error-message-wrapper[data-variant-id="${variantId}"] .product-form__error-message`);

  if (otherSameProductErrorContainers.length > 0 && cartQuantity + quantity >= maxQty) {
    otherSameProductErrorWrappers.forEach((wrapper) => {
      wrapper.removeAttribute('hidden');
    });

    otherSameProductErrorContainers.forEach((container) => {
      container.innerHTML = window.productStrings.quantityMax;
    });
  } else {
    otherSameProductErrorWrappers.forEach((wrapper) => {
      wrapper.setAttribute('hidden', true);
    });

    otherSameProductErrorContainers.forEach((container) => {
      container.innerHTML = '';
    });
  }
}

/**
 * NOTE:
 * `product-form` is the main form that powers the variant framework
 */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.variantInCart = {};
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.listenToCartChanges();
        this.setSubmitButtonInitialState();
        this.checkCurrentProductInCart();
        document.addEventListener('qty-change', this.handleQtyChange);
      }

      handleQtyChange(e) {
        console.log('cdebug handleQtyChange', this)
        const variantUnitDetails = document.querySelector(
          '#variant-unit-details'
        );
        const priceContainer = variantUnitDetails.querySelector('.unit-price');
        const qtyContainer = variantUnitDetails.querySelector('.unit-quantity');
        const currentPrice = +variantUnitDetails.dataset.price;
        let qty = +e.detail;
        const totalPrice = currentPrice * qty;

        priceContainer.innerHTML = Shopify.formatMoney(totalPrice);
        qtyContainer.innerHTML = qty;
      }

      /**
       * This is run on initialization to do a last
       * check on the current products in the cart.
       *
       * This function triggers various UI state changes to signal
       * how the UI should be depending on the current state of the product inventory.
       */
      async checkCurrentProductInCart() {
        let isProductPage = document.querySelector('body.product');
        let lineItemQtyField = null;
        if (isProductPage) {
          lineItemQtyField = document.querySelector(`[name="quantity"]`);
        } else {
          lineItemQtyField = document.querySelector(
            `#quantity-container-product-item-${this.dataset.shopifySectionId}-${this.dataset.productId} [name="quantity"]`
          );
        }
        const quantity = lineItemQtyField ? +lineItemQtyField.value : 1;
        let variantId = null;
        if (isProductPage) {
          variantId = document.querySelector('form [name=id]').value;
        } else {
          variantId = document.querySelector(
            `#product-form-product-item-${this.dataset.shopifySectionId}-${this.dataset.productId} [name=id]`
          ).value;
        }
        const loadingSpinner = this.submitButton.querySelector(
          '.loading-overlay__spinner'
        );

        try {
          const cartRequest = await SMCart.getCart();

          this.updateQtyTracker(cartRequest);

          console.log('cdebug checkCurrentProductInCart', variantId, lineItemQtyField);
          console.log(
            'cdebug window.cartQtyTracker[variantId]',
            variantId,
            window.cartQtyTracker,
            window.cartQtyTracker[variantId]
          );

          if (variantId in window.cartQtyTracker) {
            lineItemQtyField &&
              lineItemQtyField.setAttribute(
                'data-current-cart-qty',
                window.cartQtyTracker[variantId]
              );
          }

          if (this.submitButton && !this.submitButton.dataset.soldout && !this.submitButton.dataset.forceDisable) {
            this.submitButton.removeAttribute('disabled');
          }

          if (loadingSpinner) {
            loadingSpinner.classList.add('hidden');
          }
        } catch (e) {
          console.error(e);
        }

        /**
         * Setting these data attributes for max quantity messaging
         */
        const maxQty = +lineItemQtyField?.getAttribute('data-max');
        const cartQuantity = +lineItemQtyField.getAttribute(
          'data-current-cart-qty'
        );

        /**
         * Note:
         * Check first if variant is in cartQtyTracker
         * showMaxQtyMessaging should only show for cases to
         * indicate that the customer has already added all available
         * variant to cart. It is not meant to show up
         * when product is sold out.
         */
        if (variantId in window.cartQtyTracker) {
          showMaxQtyMessaging(cartQuantity, quantity, maxQty, variantId);
        }

        let submitButton = null;

        console.log('cdebug this.submitButton', this.submitButton);
        console.log('cdebug cartQuantity', cartQuantity);
        console.log('cdebug quantity', quantity);
        console.log('cdebug maxQty', maxQty);
        console.log('cdebug cartQuantity + quantity > maxQty', cartQuantity + quantity > maxQty);

        /* Disable add to cart button if cart qty and incoming qty surpasses max qty threshold */
        if (cartQuantity + quantity > maxQty) {
          if(isProductPage) {
            submitButton = document.querySelector('.product-form__submit');
            submitButton.disabled = true;
            submitButton.setAttribute('disabled', true);
            console.log('cdebug isProductPage submitButton', submitButton);
          } else {
            submitButton = document.querySelector(`#product-form-product-item-${this.dataset.shopifySectionId}-${this.dataset.productId} .product-form__submit`);
            submitButton.setAttribute('disabled', true);
            console.log('cdebug submitButton', submitButton);
          }
        }

        /* Track remaining qty while max qty is still greater than cart qty and incoming qty */
        if (maxQty >= cartQuantity + quantity) {
          lineItemQtyField.setAttribute(
            'data-max-remaining-qty',
            maxQty - cartQuantity
          );
        } else {
          lineItemQtyField.setAttribute('data-max-remaining-qty', 0);
        }

        /* Disable qty input if remaining qty is zero */
        if (lineItemQtyField.getAttribute('data-max-remaining-qty') <= 0) {
          lineItemQtyField.disabled = true;
        }
      }

      /**
       * This function tracks all line items that are in the cart and their current quantity.
       *
       *
       * @param {object} cartUpdates - see SMCart.getCart.js file for the body of this object
       *
       * @return {void}
       */
      updateQtyTracker(cartUpdates) {
        if (
          'items' in cartUpdates &&
          !Array.isArray(cartUpdates.items) &&
          cartUpdates.items.length == 0
        ) {
          return;
        }

        cartUpdates.items.forEach((lineItem) => {
          window.cartQtyTracker[lineItem.variant_id] = lineItem.quantity;
        });
      }

      /**
       * This function is invoked after adding to cart a product to update various data attributes
       * that the variant framework depends on to accurately show the state of the product form inputs.
       *
       * @param {object} cartUpdates - see SMCart.getCart.js file for the body of this object
       *
       * @return {void}
       */
      updateQtyInputDatasets() {
        const variantId = this.querySelector('form [name=id]').value;

        const lineItemQtyField = this.closest('.product-form-wrap').querySelector(
          `quantity-input [name="quantity"]`
        );
        const addButton = this.querySelector('form [name="add"]');

        // Look for any input element with value `${variantId}`
        // const addButtonByProductId = this.querySelectorAll(`.product-form__buttons [name="add"]`);

        const variantCartQty = window.cartQtyTracker[variantId];

        if(variantCartQty > 0) {
          console.log('cdebug variantCartQty 48135275839775', variantCartQty, lineItemQtyField)
          console.log('cdebug this 48135275839775', this)
          console.log('cdebug this 48135275839775', addButton)
        }

        if (lineItemQtyField) {
          lineItemQtyField.max =
            +lineItemQtyField.dataset.max - +variantCartQty;
          lineItemQtyField.dataset.maxRemainingQty =
            +lineItemQtyField.dataset.max - +variantCartQty;
          lineItemQtyField.dataset.currentCartQty = +variantCartQty;

          // Disable ATC if maximum remaining qty is zero
          if (+lineItemQtyField.dataset.maxRemainingQty == 0 && addButton) {
            addButton.disabled = true;
          }

          // Toggle disabled state of line item qty field
          if (+lineItemQtyField.dataset.maxRemainingQty <= 0) {
            lineItemQtyField.disabled = true;
          } else {
            lineItemQtyField.disabled = false;
          }

          // Show max qty messaging
          showMaxQtyMessaging(
            +variantCartQty,
            +lineItemQtyField.value,
            +lineItemQtyField.dataset.max,
            variantId
          );
        }


      }

      /**
       * Invoke all listeners to various events to properly handle product state updates
       */
      listenToCartChanges() {
        let updateQtyInputDatasets = this.updateQtyInputDatasets.bind(this);

        SMCart.on('changeInProgress', (e) => {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading-overlay__spinner').classList.remove(
            'hidden'
          );
        });

        SMCart.on('changeDone', (e) => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty'))
            this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add(
            'hidden'
          );
        });

        SMCart.on('addToCart.error', ({ error }) => {
          this.handleErrorMessage(error);
        });

        SMCart.on('addToCart', ({ rest, cartUpdates, cartUpdatesAll }) => {
          if (rest.status != 200) {
            this.handleErrorMessage(rest.description);

            const soldOutMessage =
              this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.updateQtyTracker(cartUpdatesAll);

          updateQtyInputDatasets();

          const { items, sections, sections_url } = cartUpdates;

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents({
                    ...items[0],
                    sections,
                    sections_url,
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents({
              ...items[0],
              sections,
              sections_url,
            });
          }
        });
      }

      async onSubmitHandler(evt) {
        let isProductPage = document.querySelector('body.product');
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        let formObject = {};

        new FormData(this.form).forEach(
          (value, key) => (formObject[key] = value)
        );

        const quantity = +formObject.quantity;
        const variantId = formObject.id;
        let lineItemQtyField = null;
        if (isProductPage) {
          lineItemQtyField = document.querySelector(
            `quantity-input [name="quantity"]`
          );
        } else {
          lineItemQtyField = document.querySelector(
            `#quantity-container-product-item-${this.dataset.shopifySectionId}-${this.dataset.productId} [name="quantity"]`
          );
        }

        console.log('cdebug formObject', formObject);
        console.log('cdebug lineItemQtyField', lineItemQtyField);
        console.log('cdebug quantity', quantity);

        const maxQty = +lineItemQtyField?.getAttribute('data-max');
        const cartQuantity = +lineItemQtyField.getAttribute(
          'data-current-cart-qty'
        );
        let newQuantity = 0;

        // Add remaining available inventory items to cart
        if (cartQuantity + quantity > maxQty) {
          newQuantity = maxQty - cartQuantity > 0 ? maxQty - cartQuantity : 1;
          console.log('cdebug newQuantity', maxQty, cartQuantity, newQuantity);
          formObject.quantity = newQuantity;
        }

        // Inject line item properties here
        if (formObject['properties[_pre-order-date]']) {
          formObject.properties = formObject?.properties || {};
          formObject.properties['_pre-order-date'] =
            formObject['properties[_pre-order-date]'];
        }

        console.log('cdebug formObject', formObject);

        SMCart.dispatch({
          type: 'addToCart',
          items: [
            {
              ...formObject,
            },
          ],
          source: 'product-form.js',
          sections: this.cart
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
        });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        // this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      setSubmitButtonInitialState() {
        const initalVariantId = this.form.querySelector('[name=id]').value;
        const quantityInput = document.querySelector('[name="quantity"]');
        const submitButton = this.form.querySelector('[name=add]');

        if (
          window.cartQtyTracker[initalVariantId] == quantityInput.dataset.max
        ) {
          submitButton.disabled = true;
        }
      }
    }
  );
}

/**
 * NOTE: All code below is original dawn theme product form
 * with the exception that the main form is renamed `product-form-dawn`
 */

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

if (!customElements.get('product-form-dawn')) {
  customElements.define(
    'product-form-dawn',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden'
        );

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden'
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        console.log('cdebug handleErrorMessage')

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
